module.exports = __webpack_public_path__ + "static/media/SFP-Logo-Blue.6e6cf3db.svg";